import { render } from "./Mobilebar.vue?vue&type=template&id=1650f806&scoped=true"
import script from "./Mobilebar.vue?vue&type=script&lang=js"
export * from "./Mobilebar.vue?vue&type=script&lang=js"

import "./Mobilebar.vue?vue&type=style&index=0&id=1650f806&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1650f806"]])

export default __exports__